<template>
	<div class="cand-dashboard-maincontainer">
		<header class="cand-header">
			<img
				@click="goBack()"
				class="mr-3 pointer"
				src="../../assets/img/homepage/back-arrow-blue.svg"
				alt=""
			/>
			Games
		</header>
		<header class="mob-back-header">
			<img
				@click="routeBack()"
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Games
		</header>
		<div class="pg-game-menu">
			<span @click="scrollToIns">
				<img src="../../assets/newdesign/dashboard/games/blueInfo.svg" alt="" />
				How to play?</span
			><span @click="scrollToLeaderboard"
				><img
					src="../../assets/newdesign/dashboard/games/blueLeader.svg"
					alt=""
				/>
				Leaderboards
			</span>
		</div>

		<b-container
			class="pg-grid-container app-bottom-padding"
			:class="{
				'myp-overflow-hidden':
					(!gameOvered && showResume) ||
					gameInitialized ||
					!gameInit ||
					(gameOvered && gameOverState && showStatus),
			}"
		>
			<b-container
				class="pg-left pg-position-relative"
				:class="{
					'pg-h-75':
						(gameOvered && gameOverState && showStatus) ||
						(!gameOvered && showResume),
					'': !gameInitialized,
					'parent-overflow-hidden': !gameOverState && gameInitialized,
				}"
			>
				<!-- Game Content -->

				<template v-if="gameLoading">
					<div class="height-100dvh">
						<Spinner :id="'parentgame'" class="h-100"></Spinner>
						<!-- <b-skeleton class="h-100 w-100"></b-skeleton>	 -->
					</div></template
				>

				<template v-if="!gameOverState">
					<SudokuGame
						v-if="gameType == 'sudoku'"
						@gameLoaded="onGameLoaded"
						@gameOver="onGameOver"
					></SudokuGame>
					<WordleGame
						v-else-if="gameType == 'wordle'"
						@gameLoaded="onGameLoaded"
						@gameOver="onGameOver"
					></WordleGame>
					<New2048Game
						v-else-if="gameType == '2048'"
						@gameLoaded="onGameLoaded"
						@gameOver="onGameOver"
					></New2048Game>

					<CrosswordGame
						v-else-if="gameType == 'crossword'"
						@gameOver="onGameOver"
						@gameLoaded="onGameLoaded"
					>
					</CrosswordGame>
				</template>

				<!-- Start Game overlay -->
				<div
					v-if="
						(!gameOvered && showResume) ||
						gameInitialized ||
						!gameInit ||
						gameState
					"
					class="pg-hazy-back"
				>
					<h4 v-if="gameState">YOUR GAME IS BREWING</h4>
					<h4 v-if="!gameOvered && this.gameData?.length > 0 && !gameState">
						Continue playing?
					</h4>
					<img
						v-if="gameType == '2048'"
						class="pg-hazy-img"
						src="../../assets/newdesign/home/2048.svg"
						alt=""
					/>
					<img
						v-if="gameType == 'sudoku'"
						class="pg-hazy-img"
						src="../../assets/newdesign/home/sudoku.svg"
						alt=""
					/>
					<img
						v-if="gameType == 'wordle'"
						class="pg-hazy-img"
						src="../../assets/newdesign/home/wordle.svg"
						alt=""
					/>
					<img
						v-if="gameType == 'crossword'"
						class="pg-hazy-img"
						src="../../assets/newdesign/home/crossword.svg"
						alt=""
					/>
					<h1>{{ gameName }}</h1>
					<h5>{{ gameInstructionMessage }}</h5>

					<div
						class="start-game-btn pointer"
						:style="{ pointerEvents: resume ? 'none' : 'auto' }"
						@click="
							startAnimation();
							startGame();
						"
						v-if="!gameState"
					>
						<div class="moving-child" v-if="showLine"></div>
						<span v-if="!showLine" style="white-space: nowrap">{{
							gameStartMessage
						}}</span>
					</div>
					<div
						v-if="gameStartMessage == 'Resume Game'"
						class="play-again-btn pointer"
						:style="{ pointerEvents: showLine ? 'none' : 'auto' }"
						@click="
							startAnimation();
							startGame(true);
						"
					>
						<div class="moving-child-new" v-if="resume"></div>
						<span v-if="!resume" style="white-space: nowrap">New Game</span>
					</div>
				</div>

				<!-- Game Over State -->

				<div
					v-if="gameOvered && gameOverState && showStatus && !gameState"
					class="pg-hazy-back"
				>
					<h4>{{ gameName }}</h4>

					<div class="you-tag you-won" v-if="gameWon">
						{{ showWonMessage }}
					</div>
					<div class="you-tag you-lost" v-else>
						{{ showWonMessage }}
					</div>
					<h2 class="text-center" v-if="!gameWon">{{ showMessage }}</h2>
					<span class="d-flex align-items-center">
						<h5
							class="d-flex flex-wrap align-items-center justify-content-center"
							v-if="gameWon"
						>
							You've ranked
							<span class="color-white pg-ml mr-1">#{{ rank }}</span> on the
							leaderboard!
							<span
								@click="showLeaderboard()"
								class="color-white pg-ml d-flex align-items-center justify-content-center pointer"
							>
								View now
								<img
									class="ml-2 pointer"
									src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
									alt=""
								/>
							</span>
						</h5>
					</span>
					<b-button
						@click="handleGameSelection(gameType)"
						class="play-again-btn"
					>
						<div class="moving-child" v-if="showLine"></div>
						<span v-if="!showLine" style="white-space: nowrap"
							>Play Again
						</span>
					</b-button>
					<!-- create a small line after the button -->
					<div class="pg-hazy-line"></div>
					<article v-if="gameType != 'wordle'">
						<img
							src="../../assets/newdesign/dashboard/games/wordle-small.svg"
							alt=""
						/>
						<span @click="handleGameSelection('wordle')">{{
							gameType == "wordle" ? "Play Again" : "Play Wordle"
						}}</span>
						<img
							class="mr-2 pointer"
							src="../../assets/newdesign/dashboard/games/blueRightArrow.svg"
							alt=""
							@click="handleGameSelection('wordle')"
						/>
					</article>

					<article v-if="gameType != 'sudoku'">
						<img
							src="../../assets/newdesign/dashboard/games/sudoku-small.svg"
							alt=""
						/>
						<span @click="handleGameSelection('sudoku')">{{
							gameType == "sudoku" ? "Play Again" : "Play Sudoku"
						}}</span>
						<img
							class="mr-2 pointer"
							src="../../assets/newdesign/dashboard/games/blueRightArrow.svg"
							alt=""
							@click="handleGameSelection('sudoku')"
						/>
					</article>

					<article v-if="gameType != '2048'">
						<img
							src="../../assets/newdesign/dashboard/games/2048-small.svg"
							alt=""
						/>
						<span @click="handleGameSelection('2048')">
							{{ gameType == "2048" ? "Play Again" : "Play 2048" }}
						</span>
						<img
							class="mr-2 pointer"
							src="../../assets/newdesign/dashboard/games/blueRightArrow.svg"
							alt=""
							@click="handleGameSelection('2048')"
						/>
					</article>

					<article v-if="gameType != 'crossword'">
						<img
							src="../../assets/newdesign/dashboard/games/crossword-small.svg"
							alt=""
						/>
						<span @click="handleGameSelection('crossword')">{{
							gameType == "crossword" ? "Play Again" : "Play Crossword"
						}}</span>
						<img
							class="mr-2 pointer"
							src="../../assets/newdesign/dashboard/games/blueRightArrow.svg"
							alt=""
							@click="handleGameSelection('crossword')"
						/>
					</article>
				</div>
			</b-container>
			<b-container class="pg-right">
				<!-- Only show game instructions when game has started -->
				<div class="pg-instructions">
					<wordleInstruction ref="wordle" v-if="gameType == 'wordle'" />
					<sudokuInstruction ref="sudoku" v-else-if="gameType == 'sudoku'" />
					<TwoInstruction ref="2048" v-else-if="gameType == '2048'" />
					<CrosswordInstruction
						ref="crossword"
						v-else-if="gameType == 'crossword'"
					/>
				</div>
				<RankByCollege :type="'game'" :gameType="gameType" />
				<LeaderBoard
					ref="leaderboard"
					:loadAgain="gameOvered && gameOverState && showStatus"
				/>
				<!-- <AsmntTestcards /> -->
			</b-container>
		</b-container>
	</div>
</template>

<script>
import AsmntTestcards from "@/components/Games/AsmntTestcards.vue";
import RankByCollege from "@/components/Games/RankByCollegeCard.vue";
import LeaderBoard from "@/components/Games/LeaderBoard.vue";
import CrosswordInstruction from "@/components/Games/CrosswordInstruction.vue";
import TwoInstruction from "@/components/Games/2048Instruction.vue";
import sudokuInstruction from "@/components/Games/sudokuInstruction.vue";
import wordleInstruction from "@/components/Games/wordleInstruction.vue";
import WordleGame from "./WordleGame.vue";
import SudokuGame from "./SudokuGame.vue";
import CrosswordGame from "./CrosswordGame.vue";
import New2048Game from "./New2048Game.vue";
import { getProcessedToken } from "@/utils/request";
import gamemixins from "@/components/mixin/gamemixins";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import { deleteGameState } from "@/utils/apiFunctions";
import { trackGameEnded, trackGameStarted } from '@/utils/posthogHelpers';
import { mapGetters } from "vuex";

export default {
	name: "SingleGame",
	components: {
		RankByCollege,
		LeaderBoard,
		CrosswordInstruction,
		TwoInstruction,
		sudokuInstruction,
		wordleInstruction,
		WordleGame,
		SudokuGame,
		New2048Game,
		CrosswordGame,
		Spinner,
		AsmntTestcards,
	},
	data() {
		return {
			showLine: false,
			animationTriggered: false,
			gameType: this.$route.query.gameType,
			gameId: this.$route.query.gameId,
			crossword: {},
			completedAnswers: {},
			gridState: {},
			loopvar: 4,
			hours: "00",
			minutes: "00",
			seconds: "00",
			intervalId: null,
			gameInstructionMessage: "",
			gameName: "",
			showShimmer: true,
			gameInitialized: false,
			gameInit: true,
			resume: false,
		};
	},
	mixins: [gamemixins],

	mounted() {
		this.startCountdown();
		this.setGameMessages();
		// window.addEventListener("message", this.handleMessage, false);
	},
	beforeDestroy() {
		this.gameOverState = false;
		// window.removeEventListener("message", this.handleMessage);
	},
	watch: {
		gameState() {
			if (this.gameState) {
				this.setGameMessages();
			}
		},
	},
	computed:{
		...mapGetters("userVUEX", {
			userEmail: "getUserEmail",
		}),
	},
	methods: {
		startAnimation() {
			this.animationTriggered = true;
		},
		onGameLoaded() {
			this.gameInit = true;
		},
		onGameOver(gameWon, score, word) {
			let gameDetails = {
				gameType : this.gameType,
				email:this.userEmail
			}
			trackGameEnded(gameDetails)
			this.gameOverState = true;
			this.gameOvered = true;
			this.showStatus = true;
			this.gameWon = gameWon;
			this.showLine = false;
			this.showResume = false;
			this.animationTriggered = false;
			const is2048 = this.gameType === "2048";
			const isWordle = this.gameType === "wordle";

			if (gameWon) {
				this.showWonMessage = "You Won";
				this.showMessage = is2048
					? `You are out of moves. Your score is ${score}`
					: "You Won";
				if (isWordle) this.showMessage = `The word was ${word}`;
			} else {
				this.showWonMessage = is2048 ? "You Lost" : "You Lost";
				this.showMessage = is2048
					? `You are out of moves. Your score is ${score}`
					: `Uh-oh..you lost${isWordle ? `. The word was ${word}` : ""}`;
			}

			this.getMyRank();
		},

		setGameMessages() {
			const gameMessages = {
				wordle: {
					instruction: "Guess the 5-letter word within 6 tries.",
					name: "Wordle",
				},
				sudoku: {
					instruction:
						"Fill the 9x9 grid so that each row, column, and 3x3 box contains 1-9.",
					name: "Sudoku",
				},
				2048: {
					instruction: "Combine numbered tiles to reach the tile 2048.",
					name: "2048",
				},
				crossword: {
					instruction:
						"Fill the grid with correct words based on the given clues.",
					name: "Crossword",
				},
			};

			if (this.gameState) {
				this.gameInstructionMessage =
					"Hold on while we create a new game for you. We'll be back soon.";
			} else if (gameMessages[this.gameType]) {
				const { instruction, name } = gameMessages[this.gameType];
				this.gameInstructionMessage = instruction;
				this.gameName = name;
			}
		},

		async handleGameSelection(gameType) {
			try {
				const currentRoute = this.$router.currentRoute;
				const isSameGameType =
					currentRoute.query.gameType === gameType.toString();
				if (!isSameGameType) {
					await this.$router.push({
						path: "/singlegame",
						query: {
							gameType: gameType,
						},
					});
				}
				this.gameOverState = true;
				this.gameType = gameType;
				this.gameOvered = false;
				this.showStatus = false;
				this.showResume = false;
				this.gameData = null;
				await this.getGameState(gameType, true);
				this.setGameMessages();
				if (isSameGameType) {
					this.gameOverState = true;
					this.gameOvered = true;
					this.gameInitialized = false;
					this.startAnimation();
					this.startGame();
					this.showResume = false;
				}
			} catch (error) {
				console.error("Error handling game selection:", error);
			}
		},
		startCountdown() {
			this.updateCountdown();
			this.intervalId = setInterval(this.updateCountdown, 1000);
		},
		goBack() {
			if (this.$route.query.from == "profile") {
				this.$router.replace({ path: "/myprofile" });
			} else if (this.$route.query.from == "home") {
				this.$router.replace({ path: "/Homepage" });
			} else if (this.$route.query.leaderboard) {
				this.$router.replace({
					path: "/leaderboard",
					query: { redirect: this.$route.query.redirect },
				});
			} else {
				this.$router.replace({
					path: "/games",
					query: { redirect: this.$route.query.redirect },
				});
			}
		},
		routeBack() {
			this.$router.go(-1);
		},
		updateCountdown() {
			const now = new Date();
			const endOfDay = new Date(
				now.getFullYear(),
				now.getMonth(),
				now.getDate() + 1,
				0,
				0,
				0
			);

			const remainingTime = endOfDay - now;

			const hours = Math.floor(remainingTime / (1000 * 60 * 60));
			const minutes = Math.floor(
				(remainingTime % (1000 * 60 * 60)) / (1000 * 60)
			);
			const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

			this.hours = String(hours).padStart(2, "0");
			this.minutes = String(minutes).padStart(2, "0");
			this.seconds = String(seconds).padStart(2, "0");
		},
		async startGame(deleteGame = false) {
			if (!deleteGame) {
				this.showLine = true;
			}
			if (deleteGame) {
				const deletes = await deleteGameState(this.gameType);
				this.resume = true;
			}
			this.gameInitialized = true;
			this.gameOverState = false;
			this.gameOvered = true;
			let gameDetails = {
				gameType : this.gameType,
				email:this.userEmail
			}
			trackGameStarted(gameDetails)
			setTimeout(() => {
				this.gameInitialized = false;
				this.showResume = false;
			}, 4000);
		},
		scrollToLeaderboard() {
			const element = this.$refs.leaderboard.$el;
			element.scrollIntoView({ behavior: "smooth", block: "start" });
			const headerHeight = 60;
			window.setTimeout(() => {
				window.scrollBy(0, -headerHeight);
			}, 0);
		},
		showLeaderboard() {
			if (window.innerWidth <= 1024) {
				this.$router.push({
					name: "Leaderboard",
					query: {
						gameType: this.gameType,
						redirect: true,
						from: this.$route.query.from,
					},
				});
			} else {
				this.scrollToLeaderboard();
			}
		},

		scrollToIns() {
			const element = this.$refs[this.gameType].$el;
			element.scrollIntoView({ behavior: "smooth", block: "start" });
			const headerHeight = 60;
			window.setTimeout(() => {
				window.scrollBy(0, -headerHeight);
			}, 0);
		},
	},
};
</script>

<style>
.pg-hazy-line {
	border-top: 2px dotted #e6e6e6;
	width: 70%;
	opacity: 0.2;
}
.pg-grid-container {
	display: grid;
	grid-template-columns: 2.5fr 1fr;
	gap: 10px;
	max-width: 1825px;
	padding: 0;
	margin-top: 10px;
	height: calc(100vh - 152px);
}
.pg-left {
	display: grid;
	padding: 0;
	height: 100%;
	overflow: auto;
	background-color: #d4d9e0;
	border-radius: 8px;
	max-width: 100%;
	position: relative;
}
.pg-right {
	padding: 0px;
	height: 100%;
	overflow: auto;
	max-width: 100%;
	padding-bottom: 4px;
	display: flex;
	flex-direction: column;
	gap: 15px;
}
.pg-instructions {
	order: 1;
}
.rbc-main-card {
	order: 2;
}
.cand-dash-games {
	order: 3;
}
@media (max-width: 1028px) {
	.rbc-main-card {
		order: 3;
	}
	.cand-dash-games {
		order: 2;
	}
}
.pg-right::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.pg-instruction-cont {
	background-color: #9bc9ff54;
	border-radius: 8px;
	/* margin-bottom: 10px; */
	position: relative;
	padding: 20px;
	max-width: 100%;
	text-align: left;
}
.pg-img-pos {
	position: absolute;
	right: 0px;
	top: 0px;
}

.pg-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-B);
	color: var(--bg-proTheme);
}
.pg-instruction-cont h2 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-proTheme);
}

.pg-instruction-cont h3 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: #595959;
}

.pg-instruction-cont h4 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: #333333;
	margin-bottom: 0;
}

.pg-green-txt {
	color: #50b264;
}

.pg-yellow-txt {
	color: #cab750;
}

.pg-grey-txt {
	color: #787c7e;
}

.pg-game-menu {
	display: none;
}
/* .mob-back-header {
	display: none;
} */

.pg-hazy-img {
	height: 75px;
	width: 75px;
}

.pg-hazy-back {
	background: linear-gradient(
		180deg,
		rgba(140, 140, 140, 0.8) 0%,
		rgba(38, 38, 38, 0.8) 100%
	);
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0px;
	pointer-events: auto;
	/* cursor: pointer; */
	z-index: 4;
	padding-inline: 20px;
	backdrop-filter: blur(7px);
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: center;
}

.pg-hazy-back h4 {
	font-family: "Montserrat", sans-serif;
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0.16em;
	color: #e6e6e6;
	text-shadow: 0px 4px 4px 0px #00000040;
}

.pg-hazy-back h1 {
	font-family: "Montserrat", sans-serif;
	font-size: 40px;
	font-weight: 700;
	color: #ffffff;
}

.pg-hazy-back h5 {
	font-family: "Montserrat", sans-serif;
	font-size: 20px;
	font-weight: 600;
	color: #e6e6e6;
	text-align: center;
}

.pg-hazy-back h2 {
	font-family: "Montserrat", sans-serif;
	font-size: 32px;
	font-weight: 700;
	color: #ffffff;
}

.pg-hazy-back .play-again-btn {
	border: 1px solid #20639b;
	background-color: #20639b;
	border-radius: 20px;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #e6e6e6;
	position: relative;
	width: 300px;
	height: 40px;
	overflow: hidden;
}
.pg-hazy-back .start-game-btn {
	border: 1px solid #20639b;
	background-color: #ffffff;
	border-radius: 20px;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #20639b;
	position: relative;
	width: 300px;
	height: 40px;
	overflow: hidden;
}

.pg-hazy-back .moving-child {
	width: 80px;
	height: 5px;
	background-color: #20639b;
	position: absolute;
	animation: move-and-shrink 4s linear infinite;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #20639b;
	transition: opacity 0.5s ease, transform 0.5s ease;
	border-radius: 4px;
	opacity: 0;
}

.pg-hazy-back .moving-child-new {
	width: 80px;
	height: 5px;
	background-color: #e6e6e6;
	position: absolute;
	animation: move-and-shrink 4s linear infinite;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	/* make white color */
	color: #e6e6e6;
	transition: opacity 0.5s ease, transform 0.5s ease;
	border-radius: 4px;
	opacity: 0;
}

@keyframes move-and-shrink {
	0% {
		top: 16px;
		left: 115px;
		width: 80px;
		opacity: 1;
	}
	20% {
		top: 30px;
		left: 120px;
		width: 70px;
		opacity: 1;
	}
	40% {
		top: 16px;
		left: 130px;
		width: 50px; /* Shrinks at the center */
		opacity: 1;
	}
	60% {
		top: 16px;
		left: 250px;
		width: 40px; /* Restores original width */
		opacity: 1;
	}
	80% {
		top: 16px;
		left: 3px;
		width: 70px;
		opacity: 1;
	}
	100% {
		top: 16px;
		left: 115px;
		width: 80px;
		opacity: 1;
	}
}

.pg-hazy-back article {
	width: 242px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #f2f7fbf2;
	border-radius: 8px;
	overflow: hidden;
	cursor: pointer;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #20639b;
}

.pg-hazy-back .pg-game-timer {
	background: #505250;
	border-radius: 5px;
	padding: 2px 12px;
	border: none;
	display: flex;
	align-items: center;
	gap: 10px;
	width: 340px;
}

.pg-hazy-back .pg-game-timer span {
	font-family: "Montserrat", sans-serif;
	font-size: 20px;
	font-weight: 400;
	color: #f1f1f1;
}

.pg-hazy-back .pg-game-timer h3 {
	font-family: "Montserrat", sans-serif;
	font-size: 20px;
	font-weight: 600;
	color: #f1f1f1;
	margin-bottom: 0;
}
.pg-hazy-back .pg-game-timer h3 span {
	width: 85px;
}

.color-white {
	color: #ffffff;
}

.reset-game-hover {
	background: #00bfae59;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #3b3b3b;
	border-radius: 21px;
	height: fit-content;
	position: absolute;
	right: -59px;
	top: 173px;
}

.reset-game-hover img {
	position: relative;
	z-index: 2;
	transition: all 0.3s ease; /* Added transition */
	cursor: pointer;
}

.reset-game-hover span {
	position: absolute;
	background: #00bfae59;
	height: 42px;
	display: flex;
	align-items: center;
	border-radius: 20px;
	padding-left: 40px;
	border: 1px solid #8c8c8c54;
	z-index: 1;
	left: -8px;
	top: 0px;
	opacity: 0;
	visibility: hidden;
	white-space: nowrap;
	transition: all 0.3s ease; /* Added transition */
}

/* Show span on hover of img */
.reset-game-hover:hover span {
	opacity: 1;
	visibility: visible;
	left: 0px; /* Adjust position if needed */
}

.hint-game-hover {
	background: #ffcc80bf;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #3b3b3b;
	border-radius: 21px;
	height: fit-content;
	position: absolute;
	right: -59px;
	top: 242px;
}

.hint-game-hover img {
	position: relative;
	z-index: 2;
	transition: all 0.3s ease; /* Added transition */
	cursor: pointer;
}

.hint-game-hover span {
	position: absolute;
	background: #ffcc80bf;
	height: 42px;
	display: flex;
	align-items: center;
	border-radius: 20px;
	padding-left: 40px;
	border: 1px solid #8c8c8c54;
	z-index: 1;
	left: -8px;
	top: 0px;
	opacity: 0;
	visibility: hidden;
	white-space: nowrap;
	transition: all 0.3s ease; /* Added transition */
}

/* Show span on hover of img */
.hint-game-hover:hover span {
	opacity: 1;
	visibility: visible;
	left: 0px; /* Adjust position if needed */
}

.pg-addBtn.btn-secondary,
.pg-addBtn.btn-secondary:focus {
	background-color: #20639b;
	border: 1px solid #ffffff;
	border-radius: 20px;
	padding-inline: 100px;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 600;
	box-shadow: none !important;
}
.pg-addBtn.btn-secondary:not(:disabled):not(.disabled):active,
.pg-addBtn.btn-secondary:not(:disabled):not(.disabled).active,
.show > .pg-addBtn.btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: #20639b;
	border-color: #ffffff;
}

.two-zero-btn-padding.btn-secondary {
	border-color: #20639b !important;
	padding-inline: 70px !important;
}
.iframe-height {
	height: 100%;
}
.pg-ml {
	margin-left: 6px;
}
.you-tag {
	font-family: "Montserrat", sans-serif;
	font-size: 32px !important;
	font-weight: 700 !important;

	display: flex !important;
	justify-content: center !important;

	border-radius: 8px !important;
	width: unset !important;
	padding: 5px 12px;
}
.you-won {
	color: #4caf50 !important;
	background-color: #e8f5e9 !important;
}
.you-lost {
	color: #ad1927 !important;
	background-color: #fdecea !important;
}

@media (max-width: 1028px) {
	.iframe-height {
		height: 100vh;
	}
	.mob-back-header {
		display: flex;
	}
	.pg-right {
		/* max-width: 100%; */
		height: unset;
		overflow: unset;
	}
	.pg-hazy-back .play-again-btn {
		width: 200px;
	}
	.cand-dashboard-maincontainer {
		padding: 0px;
		top: unset;
		height: 100dvh;
		overflow: hidden;
	}
	.cand-header {
		display: none;
	}
	.pg-grid-container {
		/* grid-template-columns: 1fr; */
		display: flex;
		flex-direction: column;
		margin-top: 0px;
		height: calc(
			100% - (110px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		overflow: auto;
		padding: 10px;

		width: 100%;
		background-color: #e9ecef;
		/* overflow-x: hidden; */
	}
	.pg-position-relative {
		position: relative;
	}
	.pg-left {
		/* grid-template-columns: 1fr; */
		display: unset;
		flex-shrink: 0;
		overflow: unset;
		grid-template-rows: unset;
		position: unset;
		/* height: 500px; */
		height: unset;
		background-color: #d9d9d9;
	}
	.max-100 {
		max-width: 100%;
	}
	.pg-game-menu {
		display: flex;
		gap: 15px;
		align-items: flex-end;
		height: 50px;

		padding: 0 10px 3px 10px;

		width: 100%;
	}

	.pg-game-menu span {
		font-family: "Lato", sans-serif;
		font-size: var(--size-13);
		font-weight: var(--weight-M);
		color: var(--bg-proTheme);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		background-color: #ffffff;
		border: 1px solid var(--bg-proTheme);
		border-radius: 20px;
		flex: 1;
		padding: 7px;
	}
	.pg-hazy-back .pg-game-timer {
		width: 300px;
	}
	.pg-hazy-back h4,
	.pg-hazy-back .pg-game-timer span,
	.pg-hazy-back .pg-game-timer h3 {
		font-size: 16px;
	}
	.pg-hazy-back .pg-game-timer h3 span {
		width: 70px;
	}
	.pg-hazy-back h2,
	.pg-hazy-back h1 {
		font-size: 24px;
	}
	.pg-hazy-back h5 {
		font-size: 14px;
	}
	.pg-ml {
		text-decoration: underline !important;
		width: 100%;
	}
	.pg-hazy-back .start-game-btn {
		width: 200px;
	}
	.pg-hazy-back {
		top: calc(60px + env(safe-area-inset-top));
		left: 0px;
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		position: fixed;
	}
	.reset-game-hover {
		top: unset;
		top: unset;
		bottom: -59px;
		left: 140px;
		right: unset;
		width: fit-content;
	}
	.hint-game-hover {
		top: unset;
		top: unset;
		bottom: -59px;
		right: unset;
		left: 12px;
		width: fit-content;
	}

	.reset-game-hover span {
		left: -9px;
		top: 0px;
		opacity: 1;
		visibility: visible;
		display: inline-flex;
		padding-left: 40px;
		height: 32px;
	}

	.hint-game-hover span {
		left: -9px;
		top: 0px;
		opacity: 1;
		visibility: visible;
		display: inline-flex;
		padding-left: 40px;
		height: 33px;
	}

	.reset-game-hover img,
	.hint-game-hover img {
		height: 32px;
		width: 32px;
	}
	.pg-h-75 {
		height: 75%;
	}

	@keyframes move-and-shrink {
		0% {
			top: 16px;
			left: 60px;
			width: 80px;
			opacity: 1;
		}
		20% {
			top: 30px;
			left: 65px;
			width: 70px;
			opacity: 1;
		}
		40% {
			top: 16px;
			left: 75px;
			width: 50px; /* Shrinks at the center */
			opacity: 1;
		}
		60% {
			top: 16px;
			left: 170px;
			width: 40px; /* Restores original width */
			opacity: 1;
		}
		80% {
			top: 16px;
			left: 3px;
			width: 70px;
			opacity: 1;
		}
		100% {
			top: 16px;
			left: 60px;
			width: 80px;
			opacity: 1;
		}
	}
}
</style>
